import React, { useState } from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import Table from "../../../Components/Common/Table";
import TableHead from "../../../Components/Common/TableHead";
import { Loader } from "../../../Components/Common/Loader";
import useSWR from "swr";
import { TestApiUrls } from "../../../Api/Auth/ApiUrls";
import QueryString from "qs";
import useTable from "../../../hooks/useTable";
import TestRow from "./Components/TestRow";
import NoData from "../../../Components/Common/NoData";
import Pagination from "../../../Components/Common/Pagination/Pagination";
import { useLocation } from "react-router-dom";
import Modal from "../../../Components/Common/Modal";
import TestForm from "./Components/TestForm";
import useSWRMutation from "swr/mutation";
import {
  sendPostRequestAuth,
  sendPutRequestAuth,
} from "../../../Api/swrConfig";
import { toast } from "react-toastify";
import useToastError from "../../../hooks/useErrorToast";
import Storage from "../Storage";

const tableColumnData = [
  { id: "title", label: "Title" },
  { id: "free", label: "Free" },
  { id: "category", label: "Category" },
  { id: "price", label: "Price" },
  { id: "link", label: "Link" },
  { id: "createdAt", label: "Created" },
];
const TestList = () => {
  const [row, setRow] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    free: "free",
    price: 0,
    link: "",
    category: null,
    actionButton: "",
  });
  const [errors, setErrors] = useState({});
  const { showErrorToast } = useToastError();

  const [isModalOpen, setModalOpen] = useState(false);
  const [isStorageModalOpen, setStorageModalOpen] = useState(false);
  const location = useLocation();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable({ defaultOrderBy: "" });

  const apiQueryParams = {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);
  const { isLoading, data, mutate } = useSWR(TestApiUrls.list(apiQueryString));

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Set only the field that's changed
    }));
  };

  const onEditClick = (row) => {
    setRow(row);
    handleInputChange("title", row.title);
    handleInputChange("free", row.free === false ? "paid" : "free");
    handleInputChange("price", row.price);
    handleInputChange("link", row.link);
    handleInputChange("category", row.category?._id);
    handleInputChange("actionButton", row.actionButton);
    setModalOpen(true);
  };

  const { trigger, isMutating } = useSWRMutation(
    TestApiUrls.create,
    sendPostRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );
  const { trigger: EditTrigger, isMutating: editMutating } = useSWRMutation(
    TestApiUrls.edit(row?._id),
    sendPutRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );

  const actionButtons = [
    {
      label: "Create",
      icon: faAdd,
      onClick: () => {
        setRow(null);
        setFormData({
          title: "",
          free: "free",
          price: 0,
          link: "",
          category: null,
          actionButton: "",
        });
        setModalOpen(true);
      },
    },
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.category) newErrors.title = "Category is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    const modifiedData = {
      ...formData,
      category:
        typeof formData.category === "object"
          ? formData.category.value
          : formData.category,
      free: formData.free === "free",
    };

    row ? EditTrigger(modifiedData) : trigger(modifiedData);
  };

  return (
    <div>
      <Breadcrumb actionButtons={actionButtons} />
      <Table>
        <TableHead rowCount={data?.data.length} headerData={tableColumnData} />
        <tbody className={`divide-y divide-gray-200`}>
          {!isLoading ? (
            <>
              {data?.data.map((row) => (
                <TestRow
                  key={row._id}
                  row={row}
                  mutate={mutate}
                  onEditClick={onEditClick}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="100" className="text-center py-4">
                <Loader />
              </td>
            </tr>
          )}
        </tbody>
        <NoData isNotFound={!data?.data.length && !isLoading} />
      </Table>
      <Pagination
        totalRows={data?.pagination.totalItems || 0}
        currentPage={page}
        rowsPerPage={rowsPerPage}
        currentPath={location.pathname}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal
        isOpen={isModalOpen}
        title={row ? "Edit Test" : "Create Test"}
        onConfirm={handleSubmit}
        onCancel={() => {
          setErrors({});
          setModalOpen(false);
        }}
        isLoading={isMutating || editMutating}
        formWidth
      >
        <TestForm
          errors={errors}
          handleSubmit={handleSubmit}
          onChange={handleInputChange}
          formData={formData}
          setModalOpen={setStorageModalOpen}
        />
      </Modal>
      <Modal
        isOpen={isStorageModalOpen}
        title={"Storage Manager"}
        // onConfirm={handleSubmit}
        onCancel={() => {
          setStorageModalOpen(false);
        }}
        footer={false}
      >
        <Storage
          isSelector
          onConfirm={(file) => {
            if (Array.isArray(file) && file.length)
              handleInputChange("link", file[0]?.fileUrl);
            setStorageModalOpen(false);
          }}
        />
      </Modal>
    </div>
  );
};

export default TestList;
